<app-modal *ngIf="vo$ | async; let vo">
	<div
		modal-body
		class="app-version-switcher-modal">

		<dc-alert
			*ngIf="vo.inViewMode"
			class="info"
			type="warning"
			message="warning"
			i18n-message="@@subscription.versionSwitcher.modal.description">
		</dc-alert>

		<dc-alert
			*ngIf="!vo.inViewMode"
			class="info"
			type="warning"
			message="warning"
			i18n-message="@@subscription.versionSwitcher.modal.multiple.datalink.description">
		</dc-alert>

		<app-panel
			headerHeight="3rem"
			isAlwaysOpen="true"
			hasSearchableGrid="true"
			hasRefresh="true"
			[itemsCount]="vo.switchableProjectList.elements.size"
			(search)="search($event)"
			(refresh)="refresh()">
			<div
				class="app-panel__title"
				panel-title>
				<mat-icon [svgIcon]="DcIcons.Project"></mat-icon>
				<span
					i18n="@@subscription.versionSwitcher.project.list.title">
          projects</span>
			</div>
			<div panel-info class="select-info">
				<ng-container *ngIf="selectionCount" >
					<span>{{ selectionCount }} &#32;</span>
					<span
						i18n="@@general.selectedElements">
						selected-elements</span>
				</ng-container>
			</div>

			<dx-data-grid
				keyExpr="id"
				[elementAttr]="{id: 'version-switcher-project-list',class: 'app-version-switcher-project-list'}"
				[dataSource]="vo.switchableProjectList.elements | toArray"
				[hoverStateEnabled]="true"
				[showColumnHeaders]="true"
				[allowColumnResizing]="true"
				[columnAutoWidth]="false"
				[showRowLines]="false"
				[showColumnLines]="false"
				[rowAlternationEnabled]="false"
				[showBorders]="false"
				[width]="'100%'"
				[noDataText]="''"
				(onCellHoverChanged)="onCellHover($event)"
				(onRowPrepared)="onRowPrepared($event)"
				(onCellPrepared)="onCellPrepared($event)"
				(onRowClick)="onRowClick($event)"
				(onSelectionChanged)="onSelectionChange($event)"
				(onContentReady)="onGridReady()">

				<dxo-selection
					[mode]="'multiple'"
					showCheckBoxesMode="always"></dxo-selection>

				<dxo-load-panel
					shadingColor="rgba(0,0,0,0)"
					[indicatorSrc]="DcLoaders.LoaderInfinite"
					[height]="100"
					[width]="100"
					[enabled]="true"
					[showIndicator]="true"
					[showPane]="true"
					[shading]="true"></dxo-load-panel>

				<!-- Fixable in position columns	-->
				<dxo-column-fixing [enabled]="true"></dxo-column-fixing>

				<ng-container
					*ngFor="let col of vo.switchableProjectList.availableColumns | toArray">
					<dxi-column
						*ngIf="col.field === 'subscriptionLabel'"
						[dataField]="col.field"
						[caption]="col.alias"
						[groupIndex]="col.groupIdx"
						[fixed]="false"
						[allowResizing]="true"
						[allowHiding]="true"
						[allowGrouping]="true"
						[allowSearch]="col.isSearchable"
						[allowFiltering]="col.isFilterable"
						[allowSorting]="col.canBeReordered"
						[dataType]="col.type"
						[alignment]="'left'"
						[width]="'10%'"
						[visibleIndex]="col.visibleIndex"></dxi-column>

					<dxi-column
						*ngIf="col.field === 'consumerProjectLabel'"
						[dataField]="col.field"
						[caption]="col.alias"
						[groupIndex]="col.groupIdx"
						[fixed]="false"
						[allowResizing]="true"
						[allowHiding]="true"
						[allowGrouping]="true"
						[allowSearch]="col.isSearchable"
						[allowFiltering]="col.isFilterable"
						[allowSorting]="col.canBeReordered"
						[dataType]="col.type"
						[alignment]="'left'"
						[width]="'25%'"
						[visibleIndex]="col.visibleIndex"></dxi-column>
					<dxi-column
						*ngIf="col.field === 'consumerProjectVersion'"
						[dataField]="col.field"
						[caption]="col.alias"
						[groupIndex]="col.groupIdx"
						[fixed]="false"
						[allowResizing]="true"
						[allowHiding]="true"
						[allowGrouping]="true"
						[allowSearch]="col.isSearchable"
						[allowFiltering]="col.isFilterable"
						[allowSorting]="col.canBeReordered"
						[dataType]="col.type"
						[alignment]="'left'"
						[width]="'15%'"
						[visibleIndex]="col.visibleIndex"
						cellTemplate="consumerProjectVersionTemplate"></dxi-column>
					<dxi-column
						*ngIf="col.field === 'profileLabel'"
						[dataField]="col.field"
						[caption]="col.alias"
						[groupIndex]="col.groupIdx"
						[fixed]="false"
						[allowResizing]="true"
						[allowHiding]="true"
						[allowGrouping]="true"
						[allowSearch]="col.isSearchable"
						[allowFiltering]="col.isFilterable ?? false"
						[allowSorting]="col.canBeReordered"
						[dataType]="col.type"
						[alignment]="'left'"
						[width]="'25%'"
						[visibleIndex]="col.visibleIndex"></dxi-column>
					<dxi-column
						*ngIf="col.field === 'currentProducerVersion'"
						[dataField]="col.field"
						[caption]="col.alias"
						[groupIndex]="col.groupIdx"
						[fixed]="false"
						[allowResizing]="true"
						[allowHiding]="true"
						[allowGrouping]="true"
						[allowSearch]="col.isSearchable"
						[allowFiltering]="col.isFilterable ?? false"
						[allowSorting]="col.canBeReordered"
						[dataType]="col.type"
						[alignment]="'left'"
						[width]="'15%'"
						[visibleIndex]="col.visibleIndex"
						cellTemplate="currentProducerVersionTemplate"></dxi-column>
					<dxi-column
						*ngIf="col.field === 'blockedReason'"
						[dataField]="col.field"
						[caption]="col.alias"
						[groupIndex]="col.groupIdx"
						[fixed]="false"
						[allowResizing]="true"
						[allowHiding]="true"
						[allowGrouping]="true"
						[allowSearch]="col.isSearchable"
						[allowFiltering]="col.isFilterable ?? false"
						[allowSorting]="col.canBeReordered"
						[dataType]="col.type"
						[alignment]="'left'"
						[width]="'10%'"
						[visibleIndex]="col.visibleIndex"
						cellTemplate="blockedReasonTemplate"></dxi-column>
				</ng-container>

				<div *dxTemplate="let cell of 'consumerProjectVersionTemplate'">
						<div class="version-badge">
							<span>{{cell.data['consumerProjectVersion']}}</span>
						</div>
				</div>

				<div *dxTemplate="let cell of 'currentProducerVersionTemplate'">
					<div class="version-badge">
						<span>{{cell.data['currentProducerVersion']}}</span>
					</div>
				</div>

				<div *dxTemplate="let cell of 'blockedReasonTemplate'" class="blocked-reason">
					<app-overlay-badge
						*ngIf="cell.data['blockedReason'] !== VersionSwitchBlockedReason.None"
						class="warning"
						[icon]="ComponentIcons.Warning"
						[active]="true"
						[isOpen]="vo.openedOverlay === cell.key"
						(overlayDismiss)="closeColumnsPopover()"
						(click)="openPopover($event, cell.key)">
						<app-popover
							class="warning"
							overlayContent
							label="reason"
							i18n-label="@@subscription.versionSwitcher.project.list.column.blockedReason"
							[icon]="{ iconName: ComponentIcons.Warning }"
							(adbPopoverClose)="closeColumnsPopover()">

							<ng-container
								*ngTemplateOutlet="blockedReasonTemplate; context: { $implicit: cell.data['blockedReason'] }">
							</ng-container>
						</app-popover>
					</app-overlay-badge>
				</div>

				<!-- Sorting	-->
				<dxo-sorting mode="multiple"></dxo-sorting>

				<!-- Pagination -->
				<dxo-paging [pageSize]="10"></dxo-paging>

				<dxo-pager [visible]="true"></dxo-pager>

				<!-- Filterable columns	-->
				<dxo-header-filter [visible]="true"></dxo-header-filter>

				<dxo-filter-row [visible]="true"></dxo-filter-row>

			</dx-data-grid>
			<ng-container
				*ngIf="vo.switchableProjectList.elements.size === 0"
				[ngTemplateOutlet]="noData"></ng-container>
		</app-panel>

	</div>

	<div modal-footer  class="app-version-switcher-modal__footer">
		<app-button
			[attr.data-disabled]="selectionCount === 0 || vo.isSwitchingVersion"
			id="{{ cmpId }}-switch-btn"
			[isInProgress]="vo.isSwitchingVersion"
			[isDisabled]="selectionCount === 0 || vo.isSwitchingVersion"
			[loaderSize]="15"
			(click)="launchAction()"
			i18n="@@subscription.versionSwitcher.action.btn">
			validate</app-button>
	</div>
</app-modal>

<ng-template #noData>
	<div class="no-data-template">
		<mat-icon
			[svgIcon]="DcIcons.Project"></mat-icon>
		<span
			i18n="@@subscription.versionSwitcher.project.list.noData">
			consumed-projects</span>
	</div>
</ng-template>

<ng-template #blockedReasonTemplate let-reason>
	<div [ngSwitch]="reason">
		<span
			*ngSwitchCase="VersionSwitchBlockedReason.VersionNotPublished"
			i18n="@@subscription.versionSwitcher.project.blockedReason.versionNotPublished">
			version-not-published</span>

		<span
			*ngSwitchCase="VersionSwitchBlockedReason.ProfileIncompatible"
			i18n="@@subscription.versionSwitcher.project.blockedReason.profileIncompatible">
      profile-incompatible
    </span>

		<span
			*ngSwitchCase="VersionSwitchBlockedReason.ProfileGone"
			i18n="@@subscription.versionSwitcher.project.blockedReason.profileGone">
      profile-gone
    </span>

		<span
			*ngSwitchCase="VersionSwitchBlockedReason.AccessGone"
			i18n="@@subscription.versionSwitcher.project.blockedReason.accessGone">
      access-gone
    </span>

		<span
			*ngSwitchCase="VersionSwitchBlockedReason.RepositoryRefused"
			i18n="@@subscription.versionSwitcher.project.blockedReason.repositoryRefused">
      repository-refused
    </span>

		<span
			*ngSwitchCase="VersionSwitchBlockedReason.NotInOffer"
			i18n="@@subscription.versionSwitcher.project.blockedReason.notInOffer">
      not-in-offer
    </span>

		<span
			*ngSwitchCase="VersionSwitchBlockedReason.Authorization_paused"
			i18n="@@subscription.versionSwitcher.project.blockedReason.authorizationPaused">
      not-in-offer
    </span>
	</div>
</ng-template>
